export default "__VITE_ASSET__23b4c07e__"